import { Component, Input, OnInit } from '@angular/core';
import { BasicButtonColors, IconModes, BasicButtonSizes, BasicButtonDensityEnum } from '@app/shared/enums/buttons';
import { TranslateService } from '@ngx-translate/core';
import { BasicButtonComponent } from '../basic-button/basic-button.component';

@Component({
  selector: 'cm-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
})
export class IconButtonComponent extends BasicButtonComponent implements OnInit {
  @Input() icon = '';
  @Input() hasRipple = true;
  @Input() label: string;
  @Input() iconMode: IconModes = IconModes.FILLED;
  @Input() density: BasicButtonDensityEnum = BasicButtonDensityEnum.DEFAULT;
  @Input() color: BasicButtonColors = BasicButtonColors.SECONDARY;
  size: BasicButtonSizes = BasicButtonSizes.MEDIUM;
  @Input() disabled: boolean;
  @Input() dataCy: string;

  constructor(protected ts: TranslateService) {
    super(ts);
  }

  preventDefault(event): void {
    event.preventDefault();
  }
}
